// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"869":"71a6931f8945d1ca","3637":"f70529d82e1940c5","5690":"07077b79103edc66"}[chunkId] + ".js";
};